<template>
    <div class="mediaMain">
        <loader v-if="mediaLoading"/>
        <h4>Files</h4>
        <div v-show="mediaList.length > 0">
            <v-client-table :data="mediaList" :columns="mediaGridSpec.columns" :options="mediaGridSpec.options">
            <template slot="view" slot-scope="props">
                <div style="text-align: center;">
                    <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(props.row.mediaId, props.row.mediaTypeId, props.row.parentId, props.row.filename)"></a>
                </div>
            </template>
            <template slot="delete" slot-scope="props">
                <div style="text-align: center;" v-if="!formDisabled">
                    <a class="fa fa-ban" style="font-size: 18px;" target="_blank" v-on:click="mediaRemove(props.row.mediaId)"></a>
                </div>
            </template>
            </v-client-table>
        </div>
        <div>
            <fieldset :disabled="formDisabled">
                <form @submit.prevent="submitFile" class="form-horizontal" data-vv-scope="mediaFile">
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.newFile') }">
                        <label class="col-md-3 control-label">File</label>
                        <div class="col-md-4">
                            <input name="newFile" ref="newFile" class="form-control" type="file" v-validate="'required'">
                            <div><span v-show="errors.has('mediaFile.newFile')" class="has-error">File is required</span></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-3"></div>
                        <div class="col-md-8">
                            <div v-show="errors.any('mediaFile')">
                                <span class="has-error">Validation issues must be corrected prior to submit</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-3"></div>
                        <div class="col-md-8">
                            <div v-show="serverErrorList.length > 0">
                                <span class="has-error">Validation issues must be corrected prior to submit</span>
                                <ul class="has-error">
                                    <li v-for="serverError in serverErrorList" :key="serverError">{{ serverError }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-3">
                        </div>
                        <div class="col-md-3" v-if="!formDisabled">
                            <button name="button2" class="btn btn-primary btn-block" type="submit" style="width:120px;">Upload File</button>
                        </div>
                    </div>
                </form>
            </fieldset>
        </div>
        <div class="row" v-if="shapeFileAppend">
            <div class="col-md-3">Select shape file for GIS append</div>
            <div class="col-md-4">
                <select name="mediaAppend" class="form-control" v-model="shapeFileAppendMediaId">
                    <option :value='null'>Select Shape File</option>
                    <option :value='-1'>None</option>
                    <option v-for="media in mediaList" v-bind:value="media.mediaId" :key="media.mediaId">
                        {{media.filename}}
                    </option>
                </select>
            </div>
            <div class="col-md-2">
                <button name="button2" class="btn btn-primary btn-block" v-on:click="$emit('shapeFileAppendSave', shapeFileAppendMediaId)">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import mediaService from '../services/mediaService'
import loader from '../components/Loader.vue'

export default {
    components: {
        loader
    },
    name: 'media',
    props: {
        mediaTypeId: { required: true },
        parentId: { required: true },
        formDisabled: { default: false },
        loadOnMount: { default: true },
        type: { default: '' },
        shapeFileAppend: { default: false }
    },
    watch: {
        parentId: function () {
            this.refreshMedia()
        },
        type: function () {
            this.refreshMedia()
        }
    },
    data: function () {
        return {
            isDebug: false,
            mediaLoading: false,
            serverErrorList: [],
            mediaGridSpec: {
                columns: ['view', 'filename', 'shapeFileCurrentLayerGisJobStatus', 'shapeFileCurrentLayerIndex', 'shapeFileLayerCount', 'shapeFileProcessingCompleteDate', 'createdBy', 'createdDate', 'delete'],
                tableData: [],
                options: {
                    filterable: false,
                    dateFormat: 'MM/DD/YYYY, HH:mm A',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['shapeFileProcessingCompleteDate', 'createdDate'],
                    headings: {
                        filename: 'Filename',
                        shapeFileCurrentLayerGisJobStatus: 'Status',
                        shapeFileCurrentLayerIndex: 'Layers Processed',
                        shapeFileLayerCount: 'Layer Count',
                        shapeFileProcessingCompleteDate: 'Processing Complete Date',
                        createdBy: 'Uploaded By',
                        createdDate: 'Created Date'
                    }
                }
            },
            mediaList: [],
            mediaRefreshIntervalId: null,
            mediaRefreshCount: 0,
            shapeFileAppendMediaId: null
        }
    },
    computed: {
        componentName: function () {
            return 'Media ' + this._uid
        },
        continueMediaRefreshCheck: function () {
            return this.mediaList && this.mediaList.length > 0 && this.mediaRefreshCount < 100 && this.mediaList.some(x => {
                return !x.shapeFileProcessingCompleteDate && x.isShapeFile
            })
        },
        stopMediaRefreshCheck: function () {
            return this.mediaList && this.mediaList.length > 0 && !this.mediaList.some(x => {
                return !x.shapeFileProcessingCompleteDate && x.isShapeFile
            })
        }
    },
    created () {
        loggingService.log(this.isDebug, this.componentName, 'created')

        this.$on('media_update', function () {
            loggingService.log(this.isDebug, 'Media', 'mounted - event - media_update - reloading data')
            this.loadMedia()
        })
    },
    mounted () {
        loggingService.log(this.isDebug, this.componentName, 'mounted ' + this._uid)
        loggingService.log(this.isDebug, this.componentName, 'mediaTypeId: ' + this.mediaTypeId + ', parentId: ' + this.parentId)

        if (this.loadOnMount) {
            this.loadMedia()
        } else {
            this.mediaRefresh()
        }
    },
    methods: {
        loadMedia () {
            loggingService.log(this.isDebug, this.componentName, 'loadMedia, mediaTypeId: ' + this.mediaTypeId + ', parentId: ' + this.parentId)

            if (this.mediaTypeId && this.parentId) {
                this.mediaLoading = true

                var handle = this
                return mediaService.list(this.$http, this.mediaTypeId, null, this.parentId).then(function (response) {
                    handle.mediaList = response.data
                    handle.mediaLoading = false
                    handle.mediaRefresh()
                    return response
                })
            }
        },
        refreshMedia () {
            if (this.mediaTypeId && this.parentId) {
                return mediaService.list(this.$http, this.mediaTypeId, null, this.parentId).then(response => {
                    if (this.type === 'isolateShapeFile') {
                        this.mediaList = response.data.filter(x => x.isShapeFile)
                    } else if (this.type === 'isolateOtherFile') {
                        this.mediaList = response.data.filter(x => !x.isShapeFile)
                    } else {
                        this.mediaList = response.data
                    }
                    return response
                })
            } else {
                return
            }
        },
        mediaRefresh () {
            this.mediaRefreshCount = 0
            if (this.mediaRefreshIntervalId) clearInterval(this.mediaRefreshIntervalId)
            this.$emit('mediaRefreshStarted')
            if (this.stopMediaRefreshCheck) {
                this.$emit('mediaRefreshComplete')
                return
            }
            this.mediaRefreshIntervalId = setInterval(() => {
                if (this.continueMediaRefreshCheck) {
                    this.mediaRefreshCount++
                    this.refreshMedia().then(response => {
                        if (this.stopMediaRefreshCheck) {
                            clearInterval(this.mediaRefreshIntervalId)
                            this.$emit('mediaRefreshComplete')
                        }
                    })
                } else {
                    clearInterval(this.mediaRefreshIntervalId)
                    this.$emit('mediaRefreshComplete')
                }
            }, 5000)
        },
        submitFile () {
            loggingService.log(this.isDebug, this.componentName, 'submitFile')
            this.$validator.validateAll('mediaFile').then(result => {
                loggingService.log(this.isDebug, this.componentName, 'submitFile - mediaTypeId: ' + this.mediaTypeId + ', parentId: ' + this.parentId)
                if (result) {
                    loggingService.log(this.isDebug, this.componentName, 'submitFile - form validated')

                    var handle = this
                    mediaService.putFile(this.$http, this.mediaTypeId, null, this.parentId, this.$refs['newFile'].files[0]).then(function (response) {
                        loggingService.log(handle.isDebug, handle.componentName, 'submitFile - upload complete')

                        handle.$refs['newFile'].value = ''

                        //refresh media
                        handle.refreshMedia().then(response => {
                            //reset mediaRefresh
                            clearInterval(handle.mediaRefreshIntervalId)
                            handle.mediaRefresh()
                        })
                    })
                } else {
                    loggingService.log(this.isDebug, 'Media', 'submitFile - invalid form')
                }
            })
        },
        mediaDownloadRow (mediaId, mediaTypeId, parentId, filename) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'mediaDownloadRow - mediaId: ' + mediaId + ', mediaTypeId: ' + mediaTypeId + ', parentId: ' + parentId)

            mediaService.get(this.$http, mediaId, mediaTypeId, null, parentId).then(function (response) {
                mediaService.saveFileToDownload(response, filename)
            })
        },
        mediaRemove (mediaId) {
            if (confirm('Are you sure you want to remove this file?')) {
                mediaService.removeByMediaId(this.$http, mediaId).then(result => {
                    this.loadMedia()
                })
            }
        }
    }
}
</script>



<style>
    .mediaMain {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 5px;
        background-color: #f5f5f5;
    }
</style>



// WEBPACK FOOTER //
// Media.vue?1c82c9ea